// extracted by mini-css-extract-plugin
export default {"formHeading":"BL-z","form":"CL-z","submitBtn":"DL-z","disabled":"EL-z","input":"FL-z","error":"GL-z","submitMsg":"HL-z","signIn":"IL-z"};